import React from "react";
import { useNavigate, Link } from "react-router-dom";

export default function SalesHome() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen surface flex items-center justify-center p-6">
      <div className="max-w-3xl text-center">
        <div className="text-mist uppercase tracking-[.25em] text-xs mb-4">
          Experience • Spirit • Technologies
        </div>
        <h1 className="text-ice text-4xl font-bold mb-4">
          Sales Site
        </h1>
        <p className="text-mist text-lg mb-2">
          (Non-Authoritative)
        </p>
        <p className="text-mist/80 mb-8">
          Governed by Logical Canvas
        </p>
        
        <div className="border border-edge bg-ink rounded-hard p-6 text-left mb-8">
          <h2 className="text-ice text-xl font-semibold mb-4">Transaction Completion Model</h2>
          <ul className="text-mist space-y-2">
            <li>✓ <strong className="text-ice">Transactions</strong> are the integration surface</li>
            <li>✓ <strong className="text-ice">Invoices</strong> are customer receipts (nested in transactions)</li>
            <li>✓ <strong className="text-ice">Open</strong> transactions allow editing</li>
            <li>✓ <strong className="text-ice">Completed</strong> transactions lock invoices</li>
            <li>✓ Finance consumes <strong className="text-ice">completed transactions</strong></li>
            <li>✓ SCM attaches tracking to <strong className="text-ice">transactions</strong></li>
            <li>✓ <strong className="text-ice">Zero Trust</strong> — no direct cross-system mutation</li>
          </ul>
        </div>

        <div className="grid grid-cols-3 gap-4">
          <button 
            onClick={() => navigate('/sales/transactions')}
            className="bg-brand text-ink px-8 py-4 rounded-none font-semibold text-lg hover:opacity-90 transition-opacity"
          >
            Sales Transactions →
          </button>

          <button 
            onClick={() => navigate('/logical-canvas')}
            className="border border-edge text-ice px-8 py-4 rounded-none font-semibold text-lg hover:bg-white/5 transition-colors"
          >
            Logical Canvas →
          </button>

          <button
            onClick={() => navigate('/sales/billing')}
            className="bg-brand/10 border border-brand/30 text-white px-8 py-4 rounded-none font-semibold text-lg hover:bg-brand/20 transition-colors"
          >
            Billing Transactions →
          </button>
        </div>
        
        <div className="mt-6">
          <button
            onClick={() => navigate('/sales-center')}
            className="mt-4 inline-block bg-amber-600 text-ink px-4 py-2 rounded font-medium hover:opacity-90"
          >
            Sales Center →
          </button>
          <div className="mt-4">
            <Link to="/receive-order" className="text-blue-400 underline">
              Receive Order Dev View →
            </Link>
          </div>
        </div>
        
        <div className="mt-6 text-center text-mist/70 text-xs">
          <p>Transactions → Transaction Detail → Invoice View</p>
          <p className="mt-1">Invoices are always accessed through their parent transaction</p>
        </div>

        <div className="mt-8 text-mist/70 text-sm">
          <p>Users act • Systems produce artifacts • Policies move artifacts</p>
          <p className="mt-1">No system mutates another system directly</p>
        </div>
      </div>
    </div>
  );
}
